import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Outreach area; each part uses its own slice of it */
import styles from './Plug.module.scss';
/* eslint-enable css-modules/no-unused-class */

export type PlugState = 'idle' | 'busy' | 'error' | 'off';

interface PlugAvatarProps {
  size?: 16 | 24 | 40;
  state?: PlugState;
  className?: string;
}

/**
 * Plug, the Outreach agent (design outreach p1): a plug glyph (two prongs, a round body, a cord) on
 * the brand gradient disc. 16 inline, 24 in rows and chips, 40 in headers. The busy ring is static.
 */
const PlugAvatarComponent: React.FC<PlugAvatarProps> = ({ size = 24, state = 'idle', className }) => (
  <span
    className={clsx(
      styles.plug,
      size === 16 && styles.size16,
      size === 40 && styles.size40,
      state === 'busy' && styles.busy,
      state === 'error' && styles.error,
      state === 'off' && styles.off,
      className
    )}
    aria-hidden="true"
    data-testid="plug-avatar"
  >
    <svg
      className={styles.glyph}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 3v5M15 3v5" />
      <path d="M6 8h12v3a6 6 0 0 1-12 0Z" />
      <path d="M12 17v4" />
    </svg>
  </span>
);

export const PlugAvatar = TypedMemo(PlugAvatarComponent);
